import { configureStore } from '@reduxjs/toolkit'
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync'
import rootSaga from './sagas'
import rootReducer from './redux-slices'
import { LOCAL_STORAGE_KEY_PREFIX, LOCAL_STORAGE_KEYS } from '../constants/storage'

const persistConfig = {
  key: LOCAL_STORAGE_KEYS.PERSIST_STATE.replace(LOCAL_STORAGE_KEY_PREFIX, ''),
  keyPrefix: LOCAL_STORAGE_KEY_PREFIX,
  version: 1,
  storage,
  // Persist only the 'uiConfig' slice in local storage
  whitelist: ['uiConfig', 'login']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const sagaMiddleware = createSagaMiddleware()

const stateSyncMiddleware = createStateSyncMiddleware({
  // Only synchronize the 'setTableColumnSelection' action from the 'uiConfig' slice across tabs/windows
  whitelist: ['uiConfig/setTableColumnSelection', 'login/superAdminLoginSuccess', 'login/tenantLoginSuccess']
})

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(sagaMiddleware, stateSyncMiddleware),
  devTools: process.env.NODE_ENV !== 'production'
})

sagaMiddleware.run(rootSaga)

// Initializes a listener to receive Redux actions dispatched from other tabs/windows.
// This enables real-time state synchronization across multiple instances of the application.
initMessageListener(store)

export default store
